import React, { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ThreeDDesign = () => {
  const { t } = useTranslation();
  const containerRef = useRef(null);
  const [rotation, setRotation] = useState({ x: 0, y: 0 });
  const [selectedCard, setSelectedCard] = useState(null);
  const [showFullDesc, setShowFullDesc] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
const dir = t('direction') || 'ltr';
  const cards = [
    {
      id: 1,
      title: t('Medical Equipment Maintenance'),
      shortDescription: t('Ensuring your devices run smoothly...'),
      fullDescription: t('Medical Equipment Maintenance Full'),
      image: '/image/Maintenance.png',
      z: 40,
      xOffset: -140,
    },
    {
      id: 2,
      title: t('Medical Equipment Supplying'),
      shortDescription: t('High-quality medical devices supplied...'),
      fullDescription: t('Medical Equipment Supplying Full'),
      image: '/image/Supply.png',
      z: 90,
      xOffset: 0,
    },
    {
      id: 3,
      title: t('Hospital and Clinics Maintenance'),
      shortDescription: t('Comprehensive facility upkeep...'),
      fullDescription: t('Hospital and Clinics Maintenance Full'),
      image: '/image/Men.png',
      z: 40,
      xOffset: 140,
    },
  ];


  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

    useEffect(() => {
    setSelectedCard(cards[0]);
    setShowFullDesc(false);
  }, [t]);

  const handleMouseMove = (e) => {
    if (!containerRef.current || isMobile) return;
    const rect = containerRef.current.getBoundingClientRect();
    const offsetX = e.clientX - rect.left - rect.width / 2;
    const offsetY = e.clientY - rect.top - rect.height / 2;
    const rotateX = (-offsetY / (rect.height / 2)) * 10;
    const rotateY = (offsetX / (rect.width / 2)) * 15;
    setRotation({ x: rotateX, y: rotateY });
  };


 const handleMouseLeave = () => {
    setRotation({ x: 0, y: 0 });
  };

  const createHoverHandlers = () => {
    const refs = cards.reduce((acc, card) => {
      acc[card.id] = React.createRef();
      return acc;
    }, {});

    const handleCardMouseMove = (e, ref) => {
      if (isMobile) return;
      const rect = ref.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const rotateX = ((y - centerY) / centerY) * 12;
      const rotateY = ((x - centerX) / centerX) * 12;
      ref.current.style.transform = `translateZ(${ref.current.dataset.z}px) translateX(${ref.current.dataset.x}px) rotateX(${-rotateX}deg) rotateY(${rotateY}deg) scale(1.07)`;
      ref.current.style.boxShadow = '0 40px 60px rgba(0,0,0,0.4)';
    };

    const handleCardMouseLeave = (ref) => {
      if (isMobile) return;
      ref.current.style.transform = `translateZ(${ref.current.dataset.z}px) translateX(${ref.current.dataset.x}px) rotateX(0deg) rotateY(0deg) scale(1)`;
      ref.current.style.boxShadow = '0 25px 40px rgba(0,0,0,0.25)';
    };

    return { refs, handleCardMouseMove, handleCardMouseLeave };
  };

  const { refs, handleCardMouseMove, handleCardMouseLeave } = createHoverHandlers();

  const styles = {
    container: {
      width: '100%',
      height: isMobile ? 'auto' : '100vh',
      background: 'linear-gradient(135deg, #2a3a52, #1b2233)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      perspective: isMobile ? 'none' : '1600px',
      userSelect: 'none',
      overflow: isMobile ? 'visible' : 'hidden',
      position: 'relative',
      fontFamily: "'Montserrat', sans-serif",

      paddingTop: '30px',
      marginTop: '30px',
      borderTopLeftRadius: '50px',
      borderBottomRightRadius: '50px',

    },
    header: {
      fontSize: isMobile ? '2rem' : '3rem',
      fontWeight: '800',
      color: '#CE8238',
      textShadow: '0 3px 10px #0057A4',
      marginBottom: isMobile ? '15px' : '20px',
      textAlign: 'center',
    },
    scene: isMobile
      ? {
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
        padding: '0 15px 30px',
      }
      : {
        width: '850px',
        height: '450px',
        position: 'relative',
        transformStyle: 'preserve-3d',
        transition: 'transform 0.2s ease',
        transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`,
      },
    card: isMobile
      ? {
        position: 'relative',
        width: '100%',
        maxWidth: '320px',
        minHeight: '360px',
        boxShadow: '0 10px 20px rgba(0,0,0,0.25)',
        cursor: 'pointer',
        padding: '15px',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        borderTopLeftRadius: '50px',
        borderBottomRightRadius: '50px',
        background: 'linear-gradient(135deg, #2a3a52, #1b2233)',
        border: "2px solid white",
        backdropFilter: 'blur(15px)',
        color: '#fff',
        display: 'flex',
        textAlign: 'center',
      }
      : {
        width: '280px',
        height: '400px',
        position: 'absolute',
        top: '25px',
        borderTopLeftRadius: '50px',
        borderBottomRightRadius: '50px',
        background: 'linear-gradient(135deg, #2a3a52, #1b2233)',
        borderTop: `2px solid white`,
        borderLeft: `2px solid #CE8238`,
        backdropFilter: 'blur(20px)',
        boxShadow: '0 25px 40px rgba(0,0,0,0.25)',
        color: '#fff',
        cursor: 'pointer',
        transition: 'transform 0.25s ease, box-shadow 0.25s ease',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        padding: '30px 25px',
        textAlign: 'center',
      },
    cardImageWrapper: {
      width: '100%',
      height: '300px',
      borderRadius: '12px',
      overflow: 'hidden',
      marginBottom: '12px',
    },
    cardImage: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      display: 'block',
    },
    title: {
      fontSize: isMobile ? '1.4rem' : '1.9rem',
      fontWeight: 700,
      marginBottom: '10px',
      textShadow: '0 3px 10px #0057A4',
    },
    desc: {
      fontSize: '0.95rem',
      lineHeight: 1.5,
      opacity: 0.9,
    },
    glow: {
      display: isMobile ? 'none' : 'block',
      position: 'absolute',
      bottom: '10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '750px',
      height: '300px',
      background: 'radial-gradient(circle at center, rgba(0, 255, 255, 0.15), transparent 80%)',
      filter: 'blur(120px)',
      pointerEvents: 'none',
      zIndex: 0,
    },
    sidePanel: isMobile
      ? { display: 'none' }
      : {
        position: 'absolute',
        top: 0,
        right: 0,
        width: '320px',
        height: '95%',
        background: '#1b2233',
        borderTopLeftRadius: '50px',
        borderBottomRightRadius: '50px',

        boxShadow: '-10px 0 30px rgba(0, 0, 0, 0.3)',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 100,
        overflowY: 'auto',
        color: '#e0e6f2',

        /* Hide scrollbar - for WebKit browsers */
        '::-webkit-scrollbar': {
          display: 'none',
        },

        /* Hide scrollbar - for Firefox */
        scrollbarWidth: 'none',

        /* Hide scrollbar - for IE, Edge */
        msOverflowStyle: 'none',
      },
    closeButton: {
      marginLeft: 'auto',
      background: 'transparent',
      border: 'none',
      color: '#fff',
      fontSize: '1.5rem',
      cursor: 'pointer',
    },
  };

    return (
    <div
      style={styles.container}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      ref={containerRef}
    >
      <h1 style={styles.header}>{t('Our Business')}</h1>
      <div style={styles.scene}>
        {cards.map((card) => (
  <div
    key={card.id}
    ref={refs[card.id]}
    data-z={isMobile ? 0 : card.z}
    data-x={isMobile ? 0 : card.xOffset}
    style={{
      ...styles.card,
      transform: isMobile
        ? 'none'
        : `translateZ(${card.z}px) translateX(${card.xOffset}px) rotateX(0deg) rotateY(0deg) scale(1)`,
      zIndex: card.z,
    }}
    onMouseMove={(e) => handleCardMouseMove(e, refs[card.id])}
    onMouseLeave={() => handleCardMouseLeave(refs[card.id])}
    onClick={() => {
      setSelectedCard(card);
      setShowFullDesc(true);
    }}
  >
    {isMobile ? (
      <div style={styles.cardImageWrapper}>
        <img
          src={card.image}
          alt={card.title}
          style={styles.cardImage}
          draggable={false}
        />
      </div>
    ) : (
      <div
        style={{
          ...styles.cardImageWrapper,
          backgroundImage: `url(${card.image})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      />
    )}

    <div>
      <div style={{ ...styles.title, direction: dir }}>{card.title}</div>
      <div style={{ ...styles.desc, direction: dir }}>
        {isMobile ? card.fullDescription : card.shortDescription}
      </div>
    </div>
  </div>
))}

        <div style={styles.glow} />
      </div>

     {selectedCard && !isMobile && (
  <div style={styles.sidePanel}>
    <button style={styles.closeButton} onClick={() => setSelectedCard(null)}>×</button>
    <h2 style={{ fontSize: '1.3rem', marginBottom: '10px', direction: dir }}>
      {selectedCard.title}
    </h2>
    <img
      src={selectedCard.image}
      alt={selectedCard.title}
      style={{ width: '100%', borderRadius: '8px', marginBottom: '16px' }}
      draggable={false}
    />
    <p style={{ fontSize: '0.92rem', lineHeight: 1.4, direction: dir }}>
      {selectedCard.fullDescription}
    </p>
  </div>
)}
    </div>
  );
};

export default ThreeDDesign;